<template>
  <div class="tab"
       v-if="isActive">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: {
      name: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        isActive: false
      }
    },
    computed: {
      id () {
        return this.name.toLowerCase().replace(/ /g, '-')
      }
    }
  }
</script>

<style lang="scss">
  .tab {

  }
</style>



// WEBPACK FOOTER //
// Tab.vue?1ce51685